import { temporarilyNotSupport } from '../../utils'

// 视频号
export const reserveChannelsLive = /* @__PURE__ */ temporarilyNotSupport('reserveChannelsLive')
export const openChannelsUserProfile = /* @__PURE__ */ temporarilyNotSupport('openChannelsUserProfile')
export const openChannelsLive = /* @__PURE__ */ temporarilyNotSupport('openChannelsLive')
export const openChannelsEvent = /* @__PURE__ */ temporarilyNotSupport('openChannelsEvent')
export const openChannelsActivity = /* @__PURE__ */ temporarilyNotSupport('openChannelsActivity')
export const getChannelsShareKey = /* @__PURE__ */ temporarilyNotSupport('getChannelsShareKey')
export const getChannelsLiveNoticeInfo = /* @__PURE__ */ temporarilyNotSupport('getChannelsLiveNoticeInfo')
export const getChannelsLiveInfo = /* @__PURE__ */ temporarilyNotSupport('getChannelsLiveInfo')
